import React, { Component } from 'react';
import RoomForm from './RoomForm';
import SingleRoom from './SingleRoom';
import moment from 'moment';

export default class RoomsBody extends Component {
  render() {
    const { rooms, singleRoom, onTakeRoom, onSaveRoom, actualRoom, yourIndex } = this.props;

    if (singleRoom.isLoading) {
      return (<p>Ładowanie...</p>)
    }

    return (
      <div>
        {
          singleRoom.data && singleRoom.data._id ?
            <RoomForm data={singleRoom.data} yourIndex={yourIndex}
              onSubmit={(values) => onSaveRoom(singleRoom.data._id, Object.values(values))}
              onCancel={() => onSaveRoom(singleRoom.data._id, [])}/>
            :
            <table className="rooms-table">
            <thead>
              <tr>
                <th>Numer pokoju</th>
                <th>Wszystkie miejsca</th>
                <th>Wolne miejsca</th>
                <th>Podgląd pokoju</th>
              </tr>
            </thead>
            <tbody>
              {
                rooms.map( room =>
                  <SingleRoom
                    key={room._id}
                    id={room._id}
                    roomName={room.roomName}
                    size={room.size}
                    freeSize={room.freeSize}
                    time={room.endTime}
                    onTakeRoom={onTakeRoom}
                    isActualTaking={room._id === actualRoom && moment().diff(room.endTime) < 0}
                  />
                )
              }

            </tbody>
          </table>
        }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/components/RoomsBody.js